module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/logo1@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openAppShow),
      expression: "openAppShow"
    }],
    staticClass: "open-app",
    on: {
      "click": _vm.showApp
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee29433e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Top.vue
// module id = 802
// module chunks = 1